import { useState } from "react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { useLang } from "@/lib/i18n";
import { api, errDetail } from "@/lib/api";

export function RulesText({ rules }) {
  const { lang } = useLang();
  return <div className="whitespace-pre-line text-sm leading-relaxed text-slate-300" data-testid="rules-text">{rules[`text_${lang}`] || rules.text_fr}</div>;
}

export default function RulesGate({ rules, onAccepted }) {
  const { t, tErr } = useLang();
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/member/accept-rules");
      toast.success(t("rules.accepted"));
      onAccepted();
    } catch (e) { toast.error(tErr(errDetail(e))); } finally { setBusy(false); }
  };
  return (
    <div className="panel brackets p-5 sm:p-8" data-testid="rules-gate">
      <p className="eyebrow mb-2">{t("book.rulesInfo")}</p>
      <h3 className="mb-4 font-display text-3xl uppercase text-white">{t("rules.title")}</h3>
      <div className="max-h-72 overflow-y-auto rounded-lg border border-white/10 bg-black/30 p-4"><RulesText rules={rules} /></div>
      <label className="mt-5 flex cursor-pointer items-center gap-3 text-sm text-slate-200">
        <Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} data-testid="rules-accept-checkbox" />
        {t("rules.accept")}
      </label>
      <button disabled={!ok || busy} onClick={accept} data-testid="rules-accept-btn" className="btn-red mt-5 rounded-full px-6 py-3 font-semibold disabled:opacity-40">{t("rules.acceptBtn")}</button>
    </div>
  );
}
